import React, { useState } from 'react';
import './CodeSnippetManager.css';

const CodeSnippetManager = ({ label, snippets = [], onChange, placeholder = "Paste your code snippet here..." }) => {
    const [newSnippet, setNewSnippet] = useState('');
    const [expandedIndex, setExpandedIndex] = useState(null);

    const handleAdd = () => {
        if (newSnippet.trim()) {
            onChange([...snippets, newSnippet.trim()]);
            setNewSnippet('');
        }
    };

    const handleRemove = (index) => {
        onChange(snippets.filter((_, i) => i !== index));
    };

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <div className="code-snippet-manager">
            <label className="form-label fw-semibold">{label}</label>

            {/* Add new snippet */}
            <div className="mb-3">
                <textarea
                    className="form-control font-monospace"
                    rows={6}
                    value={newSnippet}
                    onChange={(e) => setNewSnippet(e.target.value)}
                    placeholder={placeholder}
                />
                <button
                    type="button"
                    className="btn btn-sm btn-primary mt-2"
                    onClick={handleAdd}
                    disabled={!newSnippet.trim()}
                >
                    <i className="bi bi-plus-circle me-1"></i> Add Snippet
                </button>
            </div>

            {/* List of existing snippets */}
            {snippets.length > 0 && (
                <div className="snippets-list">
                    <div className="text-muted mb-2 small">
                        <i className="bi bi-info-circle me-1"></i>
                        {snippets.length} snippet{snippets.length !== 1 ? 's' : ''} configured
                    </div>
                    {snippets.map((snippet, index) => (
                        <div key={index} className="snippet-item border rounded mb-2">
                            <div className="snippet-header d-flex justify-content-between align-items-center p-2 bg-light">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-link text-decoration-none p-0 d-flex align-items-center"
                                    onClick={() => toggleExpand(index)}
                                >
                                    <i className={`bi bi-chevron-${expandedIndex === index ? 'down' : 'right'} me-2`}></i>
                                    <span className="text-muted small">Snippet #{index + 1}</span>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleRemove(index)}
                                >
                                    <i className="bi bi-trash"></i>
                                </button>
                            </div>
                            {expandedIndex === index && (
                                <div className="snippet-content p-2">
                                    <pre className="mb-0 small bg-dark text-light p-2 rounded">
                                        <code>{snippet}</code>
                                    </pre>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CodeSnippetManager;
